import React from 'react';
import { FieldLabelWithHtml } from './FieldLabelWithHtml';
import { FieldDescription } from './FieldDescription';

export function FormLabel({ label, description }: { label: string; description?: string }) {
	return (
		<div>
			<FieldLabelWithHtml label={label} required={false} />
			{description && <FieldDescription>{description}</FieldDescription>}
		</div>
	);
}
